import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { NOOP, initAliveStoreIds, kapixContext, openUrl, remove } from 'kapix-components-vue3'
import colonneDroiteArticleComponentStoreCustom from './store.custom'

const storeName = 'colonneDroiteArticleComponent'
const customImplement: CustomStoreImplementationOptions = colonneDroiteArticleComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function colonneDroiteArticleComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      prendreRendezVousClick () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      imageClick () {
        openUrl('https://www.matchers.fr/expert/306', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image1Click () {
        openUrl('https://www.matchers.fr/expert/195', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image2Click () {
        openUrl('https://www.matchers.fr/expert/398', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      button1Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image3Click () {
        openUrl('https://www.matchers.fr/expert/241', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image4Click () {
        openUrl('https://www.matchers.fr/expert/342', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image5Click () {
        openUrl('https://www.matchers.fr/expert/288', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image6Click () {
        openUrl('https://www.matchers.fr/expert/622', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image7Click () {
        openUrl('https://www.matchers.fr/expert/194', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image8Click () {
        openUrl('https://www.matchers.fr/expert/247', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image10Click () {
        openUrl('https://www.matchers.fr/expert/274', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image11Click () {
        openUrl('https://www.matchers.fr/expert/158', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return colonneDroiteArticleComponentFactory(storeId)()
}

export const colonneDroiteArticleComponentRaw = colonneDroiteArticleComponentFactory()
export const colonneDroiteArticleComponent = () => colonneDroiteArticleComponentRaw() as MergeCustomStore<typeof colonneDroiteArticleComponentStoreCustom.instance>
